export default __webpack_public_path__ + "static/media/office-5.fea5b062.webp";